// Desktop shell measurements (px), shared by the shell and the layout primitives so
// page content lines up with the breadcrumb row above it.
export const SIDEBAR_WIDTH = 248;
export const CONTENT_MAX_WIDTH = 1320;
export const CONTENT_GUTTER = 40;
// Width of an unconverted page on desktop: the same column tablets get today
export const LEGACY_COLUMN_WIDTH = 720;

// Desktop renders the page area larger (text, tiles, photos, spacing alike), so the
// phone-sized components read comfortably on a big screen without restyling them. The
// scale steps up with the screen width: a laptop has no room for the bigger sizes next to
// the side panels, while a 2560px monitor would otherwise leave half the screen empty.
// Widths above are in the page's own (unscaled) pixels.
export interface DesktopScale {
  content: number;
  sidebar: number;
}

export const DESKTOP_SCALE: DesktopScale = { content: 1.1, sidebar: 1 };

// Widest first: the first step whose minWidth the viewport reaches wins
export const WIDE_DESKTOP_SCALES: { minWidth: number; scale: DesktopScale }[] = [
  { minWidth: 2200, scale: { content: 1.3, sidebar: 1.2 } },
  { minWidth: 1600, scale: { content: 1.2, sidebar: 1.1 } },
];
